module.exports = __webpack_public_path__ + "img/headerimg.ae3db9e0.png";